import axiosClient from "./axiosClient";

/**
 * Fetches the main campaign status dashboard data.
 */
export const getCampaignStatusDashboard = () => {
  return axiosClient.get("/CampaignAnalytics/status-dashboard");
};

/**
 * Fetches the top performing campaigns.
 * @param {number} count The number of top campaigns to fetch.
 */
export const getTopCampaigns = (count = 5) => {
  return axiosClient.get(`/CampaignAnalytics/top-campaigns?count=${count}`);
};
export const getCrmSummary = () => {
  return axiosClient.get("/CrmAnalytics/summary");
};

/**
 * Fetches the daily new contact trend data for the last 30 days.
 */
export const getCrmContactTrends = () => {
  return axiosClient.get("/CrmAnalytics/contact-trends");
};

/**
 * Fetches operational Priority + SLA dashboard summary.
 * @param {{fromUtc?: string, toUtc?: string, queueType?: string, page?: number, pageSize?: number}} params
 */
export const getPrioritySlaSummary = (params = {}) => {
  const query = {};

  if (params.fromUtc) {
    query.fromUtc = params.fromUtc;
  }

  if (params.toUtc) {
    query.toUtc = params.toUtc;
  }

  if (params.queueType) {
    query.queueType = params.queueType;
  }

  if (params.page) {
    query.page = params.page;
  }

  if (params.pageSize) {
    query.pageSize = params.pageSize;
  }

  return axiosClient.get("/crm/summary/priority-sla", { params: query });
};

function buildInboxAnalyticsQuery(params = {}) {
  const query = {};

  if (params.fromUtc) {
    query.fromUtc = params.fromUtc;
  }

  if (params.toUtc) {
    query.toUtc = params.toUtc;
  }

  if (params.phoneNumberId) {
    query.phoneNumberId = params.phoneNumberId;
  }

  if (params.assigneeUserId) {
    query.assigneeUserId = params.assigneeUserId;
  }

  if (params.status) {
    query.status = params.status;
  }

  if (typeof params.includeUnassigned === "boolean") {
    query.includeUnassigned = params.includeUnassigned;
  }

  return query;
}

export const getInboxAnalyticsOverview = (params = {}) => {
  return axiosClient.get("/inbox-analytics/overview", {
    params: buildInboxAnalyticsQuery(params),
    __silent401: true,
    __silent403: true,
  });
};

export const getInboxAnalyticsAssignees = (params = {}) => {
  return axiosClient.get("/inbox-analytics/assignees", {
    params: buildInboxAnalyticsQuery(params),
    __silent401: true,
    __silent403: true,
  });
};

export const getInboxAnalyticsSenders = (params = {}) => {
  return axiosClient.get("/inbox-analytics/senders", {
    params: buildInboxAnalyticsQuery(params),
    __silent401: true,
    __silent403: true,
  });
};

export const getInboxAnalyticsTrends = (params = {}) => {
  return axiosClient.get("/inbox-analytics/trends", {
    params: buildInboxAnalyticsQuery(params),
    __silent401: true,
    __silent403: true,
  });
};

export const getBillingUsageDashboard = (params = {}) => {
  const query = {};

  if (params.from) {
    query.from = params.from;
  }

  if (params.to) {
    query.to = params.to;
  }

  if (params.phoneNumberId) {
    query.phoneNumberId = params.phoneNumberId;
  }

  return axiosClient.get("/billing/usage/dashboard", {
    params: query,
    __silent401: true,
    __silent403: true,
  });
};
